<template>
  <div>
    <welcome v-if="stepPreview.kind === 'welcome'"></welcome>
    <question v-if="stepPreview.kind === 'multiple-choice' || stepPreview.kind === 'yes-no'"></question>
    <form-email v-if="stepPreview.kind === 'email'"></form-email>
    <text-field v-if="stepPreview.kind === 'text'"></text-field>
    <redirect v-if="stepPreview.kind === 'redirect'"></redirect>
    <thanks v-if="stepPreview.kind === 'thanks'"></thanks>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HighlightHelper from '../../../../../helpers/highlight';
import Question from './question/Main';
import Welcome from './welcome/Main';
import FormEmail from './email/Main';
import TextField from './text/Main';
import Redirect from './redirect/Main';
import Thanks from './thanks/Main';

let currentStep;

const highlightHelper = new HighlightHelper();

export default {
  components: {
    Question,
    Welcome,
    FormEmail,
    TextField,
    Redirect,
    Thanks,
  },
  computed: mapGetters({
    stepPreview: 'stepPreview',
  }),
  methods: mapActions([
    'canvasEnableHighlight',
    'sidebarSetElement',
    'sidebarChangePanel',
    'sidebarChangeActiveButton',
  ]),
  updated() {
    if (currentStep !== this.stepPreview) {
      currentStep = this.stepPreview;

      const actions = {
        sidebarChangePanel: this.sidebarChangePanel,
        sidebarSetElement: this.sidebarSetElement,
        canvasEnableHighlight: this.canvasEnableHighlight,
        sidebarChangeActiveButton: this.sidebarChangeActiveButton,
      };

      highlightHelper.bind(actions);
    }
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?48c6c927
 **/